<template>
  <van-popup
      v-model="showPopup"
      position="bottom"
      round
      :closeable="false"
      safe-area-inset-bottom
      :close-on-click-overlay="false"
  >
    <div class="popupView">
      <div v-for="(item,index) in list" :key="index" :class="['cellBtn ',selectItem.id == item.id ? 'activeBtn' : 'normalBtn']" @click="handleSelect(item)">
        {{item.title}}
      </div>
      <div class="popupBottomView">
        <div class="grapView"></div>
        <div class="actionView">
          <div class="cellBtn normalBtn" @click.stop="onClose">取消</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import utils from "@/utils/common";
export default {
  props: {
    show: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    show: {
      handler(val) {
        this.showPopup = val
      },
      immediate: true
    },
    defaultItem: {
      handler(val) {
        this.selectItem = val
      },
      immediate: true
    }
  },
  data() {
    return {
      showPopup: false,
      list: [
        {
          id: '1',
          title: '一个月内',
          type: 'monthTime',
          value: utils.getTime('month', 1)
        },
        {
          id: '0',
          title: '三个月内(默认)',
          type: 'monthTime',
          default: true,
          value: utils.getTime('month', 3)
        },
        {
          id: '2',
          title: '半年内',
          type: 'monthTime',
          value: utils.getTime('month', 6)
        },
        {
          id: '3',
          title: '一年内',
          type: 'monthTime',
          value: utils.getTime('month', 12)
        }
      ],
      selectItem: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleSelect(item) {
      this.selectItem = item
      this.$emit('confirm', this.selectItem)
    },
    onClose() {
      this.selectItem = {}
      this.$emit('close')
    },
    // handleConfirm() {
    //   if (Object.keys(this.selectItem).length > 0) {
    //     this.$emit('confirm', this.selectItem)
    //   }
    // }
  }
}
</script>
<style lang="less" scoped>
@import url("../style/index.css");

popupView {
  position: relative;
  height: 100%;
}

.popupTopView {
  padding: 24px 24px;
  height: calc(100% - 350px);
  overflow: scroll;

  .clearBtn {
    font-size: 24px;
    font-weight: 400;
    color: #E15554;
    line-height: 32px;
    margin-right: 24px;
  }

  .collapseBtn {
    font-size: 24px;
    font-weight: 400;
    color: #B4B4B4;
    line-height: 32px;
  }

  .filterView {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .filterTitle {
      font-size: 28px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 40px;
    }

    .filterListView {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;

      .filterItem {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        border-radius: 30px;
        padding: 0 24px;
        font-size: 26px;
        font-weight: 400;
        line-height: 36px;
        margin: 16px 16px 0 0;
      }

      .normalItem {
        background: #F2F2F2;
        color: #62615F;
        border: 2px solid #F2F2F2;
      }

      .activeItem {
        background: rgba(68, 102, 245, 0.1);
        border: 2px solid #4466F5;
        color: #4466F5;
      }
    }
  }

  /deep/ .van-cell {
    padding: 0 0 !important;

    &::after {
      border-bottom: none !important;
    }
  }

  /deep/ .van-collapse-item__content {
    padding: 0 0 !important;
  }

  /deep/ .van-collapse-item--border {
    &::after {
      border-top: none !important;
    }
  }
}
.grapView{
  width: 100%;
  height: 16px;
  background: #F2F2F2;
}
.cellBtn{
  background: #FFFFFF;
  width: 100%;
  height: 114px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: 400;
  &::after{
    content: ' ';
    border-bottom: 1px solid #E5E5E5;
    transform: scaleY(0.5);
  }
}
.normalBtn {
  color: #3B3A38;
}
.leftActiveBtn{
  background: rgb(248, 213, 65);
}
.activeBtn {
  color: #4466F5;
}
.popupBottomView {
  //position: absolute;
  //bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;

  .tipView {
    display: flex;
    flex-direction: column;
    padding: 12px 24px;
    background: #FFFAE6;

    .tipTitle {
      font-size: 24px;
      font-weight: 500;
      color: #3B3A38;
      line-height: 24px;
    }
  }

  .actionView {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 10px 32px;
    .leftBtn{
      width: calc(30% - 32px);
      margin-right: 32px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 500;
      line-height: 40px;
      color: #FFFFFF;
    }
    .rightBtn {
      width: 70%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 500;
      line-height: 40px;
      color: #FFFFFF;
    }
  }
}

</style>